const userIsLoggedIn = siteData.is_user_logged_in ? true : false
const initialState = {
	loadedScripts: [],
	userIsLoggedIn: userIsLoggedIn,
	loginIsDisabled: false,
	loginIsProcessing: false,
	loginIsProcessed: false,
	loginError: false,
	loginSuccess: false,
	loginMessage: false,
	menuIsOpen: false,
	isLoadingMenu: false,
	menuItems: siteData.site_menu,
	socialItems: siteData.site_social,
	hasSidebar: true,
	locale: siteData.locale_base,
	locales: siteData.locales
}

export default function pageReducer( state = initialState, action ) {
	switch ( action.type ) {
		case 'ADD_SCRIPT':
			return {
				...state,
				loadedScripts: [
					...state.loadedScripts,
					action.value
				]
			}

		case 'SET_LOCALE':
			return {
				...state,
				locale: action.value
			}

		case 'LOGIN':
			return {
				...state,
				userIsLoggedIn: true,
				loginError: false
			}

		case 'LOGIN_DISABLED':
			return {
				...state,
				loginIsDisabled: action.value,
				loginError: false,
				loginSuccess: false
			}

		case 'LOGIN_PROCESSING':
			return {
				...state,
				loginIsProcessing: true,
				loginIsProcessed: false,
				loginError: false,
				loginSuccess: false
			}

		case 'LOGIN_PROCESSED':
			return {
				...state,
				loginIsProcessed: true,
				loginIsProcessing: false
			}

		case 'LOGIN_ERROR':
			return {
				...state,
				loginError: true,
				loginIsProcessed: false
			}

		case 'LOGIN_SUCCESS':
			return {
				...state,
				loginSuccess: true,
				loginIsProcessed: false
			}

		case 'LOGIN_MESSAGE':
			return {
				...state,
				loginMessage: action.message
			}

		case 'LOGOUT':
			return {
				...state,
				userIsLoggedIn: false
			}

		case 'OPEN_MENU':
			return {
				...state,
				menuIsOpen: true
			}

		case 'CLOSE_MENU':
			return {
				...state,
				menuIsOpen: false
			}

		case 'REQUEST_MENU_DATA':
			return {
				...state,
				isLoadingMenu: true
			}

		case 'RECEIVE_MENU_DATA':
			return {
				...state,
				isLoadingMenu: false,
				menuItems: action.value.site_menu,
				socialItems: action.value.site_social
			}
	}

	return state
}



// WEBPACK FOOTER //
// ./redux/reducers/site.jsx